import Page from '@/features/dashboard/payments/pages/Checkout'

export default Page
